import React, { useState, useEffect } from 'react'
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import Classes from './Forms.module.css';
import useScreenWidth from '../../../../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Forms() {
    const initialForms = [
        { id: 1, name: "Intake 1", type: "Intake", status: "Submitted", created: "March 1, 2025", completed: "March 1, 2025" },
        { id: 2, name: "Onboarding 1", type: "Onboarding", status: "Working", created: "March 1, 2025", completed: "-" },
        { id: 3, name: "Setup 2", type: "Setup", status: "Submitted", created: "March 2, 2025", completed: "March 2, 2025" },
        { id: 4, name: "Implementation 3", type: "Implementation", status: "Working", created: "March 2, 2025", completed: "-" },
        { id: 5, name: "Review 4", type: "Review", status: "Submitted", created: "March 3, 2025", completed: "March 4, 2025" },
    ]

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const totalPages = Math.ceil(initialForms.length / itemsPerPage);
    const currentItems = initialForms.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialForms.length);
    const totalItems = initialForms.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            <div className={Classes.tableHeader}>
                <div className={`${Classes.headerItem} ${Classes.header1}`}>
                    <input type='checkbox' />
                </div>
                <div className={`${Classes.headerItem} ${Classes.header2}`}>
                    <h5>Name</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.header3}`}>
                    <h5>Type</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.header4}`}>
                    <h5>Status</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.header5}`}>
                    <h5>Created</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.header6}`}>
                    <h5>Completed</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.header7}`} >
                    {/* <h5>Number</h5> */}
                </div>
                {/* <div className={`${Classes.headerItem} ${Classes.header8}`} /> */}
            </div>

            <div className={Classes.tableBody}>
                {loading ? (
                    <SkeletonLoading
                        length={itemsPerPage}
                        height={isMobile ? '6rem' : '2.8rem'}
                        width="100%"
                        br="6px"
                    />
                ) : currentItems && currentItems.length > 0 ? (
                    currentItems.map((cust, idx) => (
                        <TableRow
                            key={cust._id}
                            value={cust}
                            index={idx}
                        />
                    ))
                ) : (
                    <div>No subscription found.</div>
                )}
            </div>

            <div className={Classes.pagFooter}>
                <h5 style={{ height: '1.2rem' }}>
                    {loading
                        ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                        : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                    }
                </h5>
                <Stack spacing={2} className={Classes.pagination}>
                    {loading
                        ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                        : <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            shape="rounded"
                        />
                    }
                </Stack>
            </div>
        </div>
    )
}
